// Loader served at https://<cdn>/loader.min.js. Customers include it via:
//   <script src="https://<cdn>/loader.min.js" data-vidaly-id="ABC" async></script>
// The collector bundle URL is derived from this loader's own src, so the CDN
// can move without changing customer pages.

(function (w: Window & { vidalyy?: any }, d: Document): void {
  const me = d.currentScript as HTMLScriptElement | null;
  if (!me) return;

  const id = me.getAttribute('data-vidaly-id');
  if (!id) return;

  const stub: any = function (this: unknown): void {
    (stub.q = stub.q || []).push(arguments);
  };
  stub.id = id;
  stub.t = +new Date();
  w.vidalyy = w.vidalyy || stub;

  const j = d.createElement('script');
  j.async = true;
  j.src = new URL('collector.min.js', me.src).toString();
  j.setAttribute('data-vidaly-id', id);
  me.parentNode!.insertBefore(j, me);
})(window as Window & { vidalyy?: any }, document);
